var React = require('react');

function LoaderCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M56.668 30C56.668 15.273 44.727 3.332 30 3.332S3.332 15.273 3.332 30 15.273 56.668 30 56.668 56.668 44.727 56.668 30zm0 0","stroke":"rgb(66.27451%,83.137255%,99.607843%)","key":0}),React.createElement("path",{"d":"M30 3.332a26.67 26.67 0 0 1 17.32 6.391 26.69 26.69 0 0 1 9.02 16.105 26.68 26.68 0 0 1-3.602 18.105 26.7 26.7 0 0 1-14.496 11.43","strokeLinecap":"round","stroke":"rgb(18.823529%,65.882353%,100%)","key":1})]);
}

LoaderCircle.defaultProps = {"viewBox":"0 0 60 60","width":"60","height":"60","fill":"none","strokeWidth":"4.892"};

module.exports = LoaderCircle;

LoaderCircle.default = LoaderCircle;
